export default {
	bind (el) {
		el.classList.add('wc-messagebox__btn--catch');
	}
}


// WEBPACK FOOTER //
// ./src/wc-messagebox/directives/wc-catch.js